import './About.css';
import SEO from '../components/seo/SEO';

export default function About() {
  return (
    <>
      <SEO
        title="About | Explorelrt"
        description="Learn about Explorelrt and its focus on technology information, innovation, solutions, and practical learning content."
      />

      <main className="aboutContainer">
        <h1>About</h1>

        <p className="aboutIntro">
          <strong>Welcome to explore latest updates, trends and insights.</strong>
        </p>

        <div className="aboutSection">
          <strong className="aboutSectionTitle">📖 What You Get Here:</strong>
          <ul className="aboutList">
            <li><strong>In-Depth Technical Articles</strong> – Expert guides covering coding best practices, network design, security protocols, and emerging technologies. Real solutions for real problems.</li>
            <li><strong>Honest Tool & Product Reviews</strong> – Unbiased comparisons of dev frameworks, security tools, and software solutions. See what actually works (and what doesn't).</li>
            <li><strong>Curated Technical Resources</strong> – Hand-picked reference materials and learning pathways to accelerate your technical growth.</li>
            <li><strong>Real-World Problem Solving</strong> – Practical strategies and code patterns for tackling the challenges developers face every day.</li>
          </ul>
        </div>

        <p className="aboutClosing">
          Explore articles, dig into the resources, or <strong><a href="/contact">connect with me</a></strong> to discuss your project. Let's build something incredible together.
        </p>
      </main>
    </>
  );
}
